import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import * as api from "../services/api";
import { mapperResponseToProductList } from "mappers/mapperResponseToProductList";
import { Product } from "./product";

const title = {
  en: "COLLECTION",
  es: "COLECCIÓN",
};

export const Products = ({
  originURL,
  country,
  locale,
  id,
  baseImagePath,
  baseZaraPath,
  isShowroom,
}) => {
  const [products, setProducts] = useState([]);

  const [productsToSee, setProductsToSee] = useState([]);
  const [hasMoreInfo, setHasMoreInfo] = useState(false);

  const [lastProductSeen, setLastProductSeen] = useState(0);

  const getProducts = async () => {
    const basePath = isShowroom
      ? `${originURL}/integration/1/presslab/${country}/${locale}`
      : `${originURL}/integration/pressapi/integration/1/presslab/${country}/${locale}`;
    const zaraPath = `${baseZaraPath}/${country}/${locale}`;
    try {
      const response = await api.getProducts(basePath, id);
      const newList = mapperResponseToProductList(
        response?.data?.productGroups,
        id,
        baseImagePath,
        zaraPath
      );
      setProducts(newList);
      if (newList.length > 20) {
        setProductsToSee(newList.slice(0, 20));
        setLastProductSeen(20);
        setHasMoreInfo(true);
      } else {
        setProductsToSee(newList);
      }
    } catch (e) {
      setProducts([]);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const getTitle = () => {
    return title[getDefaultLocale()];
  };

  const getDefaultLocale = () => {
    if (locale !== "es" && locale !== "en") {
      return "en";
    } else {
      return locale;
    }
  };

  const handleNext = () => {
    if (products.length > lastProductSeen + 20) {
      setProductsToSee([
        ...productsToSee,
        ...products.slice(lastProductSeen, lastProductSeen + 20),
      ]);
      setLastProductSeen(lastProductSeen + 20);
      setHasMoreInfo(true);
    } else {
      setProductsToSee([
        ...productsToSee,
        ...products.slice(lastProductSeen, products.length),
      ]);
      setLastProductSeen(products.length);
      setHasMoreInfo(false);
    }
  };

  return (
    <div className="products-container">
      <div className="title">
        <p>{getTitle()}</p>
      </div>
      <div className="section-container">
        <InfiniteScroll
          dataLength={productsToSee.length}
          scrollThreshold={0.7}
          next={handleNext}
          hasMore={hasMoreInfo}
          loader={<h4>Loading...</h4>}
        >
          {productsToSee.map((product, index) => {
            return <Product key={index} product={product} />;
          })}
        </InfiniteScroll>
      </div>
    </div>
  );
};
